import { Suspense, useState } from 'react'
import { Await, defer, Link, useSearchParams, useNavigate, useLoaderData, json } from 'react-router-dom'
import { project } from '../util/api'
import LoadingSpinner from './components/LoadingSpinner'
import Heading from './helper/Heading'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/Project.module.scss'

import { useEffect } from 'react'

export const loader = async () => {
  return defer({ project: project() })
}

export default function Project() {
  const pageName = 'پروژه های شهرداری'
  Title(pageName)

  const [loaderData, setLoaderData] = useState(useLoaderData())

  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState()
  const [showPopup, setShowPopup] = useState(false)
  let [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    document.querySelector('header span').innerText = pageName
  }, [])

  return (
    <section className={styles.section}>
      <div className="__frame" data-width={`xlarge`}>
        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <Suspense fallback={<LoadingSpinner />}>
              <Await resolve={loaderData.project} errorElement={<p>⚠️</p>}>
                {(data) => {
                  return data.map((item) => {
                    return (
                      <div className={`ms-Grid-col ms-sm12 ms-md4 ms-lg4`}>
                        <div className={`${styles.item} `}>
                          <div className={`${styles.itemBody} d-flex flex-column align-items-center justify-content-between`} style={{ columnGap: '1rem' }}>
                            {!item.video && (
                              <>
                                <figure className={styles.gallery}>
                                  <img src={`${process.env.REACT_APP_UPLOAD}images/${item.image}`} style={{ height: '250px' }} />
                                </figure>
                              </>
                            )}

                            {item.video && (
                              <>
                                <video width="100%" height={`250px`} controls>
                                  <source src={item.video} type="video/mp4" />
                                </video>
                              </>
                            )}

                            <ul>
                              <li style={{ height: `80px` }}>
                                <label>نام پروژه:</label>
                                {item.name}
                              </li>
                              <li>
                                <label>مجری:</label>
                                {item.executive}
                              </li>
                              <li>
                                <label>تاریخ شروع:</label>
                                {item.start_date}
                              </li>
                              <li>
                                <label>تاریخ اتمام:</label>
                                {item.end_date}
                              </li>
                              <li>
                                <label>بودجه اختصاص یافته:</label>
                                {item.budget}
                              </li>
                              <li style={{ height: '40px', textOverflow: 'ellipsis' }}>
                                <label>توضیحات:</label>
                                {item.description}
                              </li>
                              <li>
                                <label>
                                  میزان پیشرفت (%{item.progress}) /<mark>{item.state}</mark>:
                                </label>
                                <div className={styles.meter}>
                                  <span style={{ width: `${item.progress}%` }}></span>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )
                  })
                }}
              </Await>
            </Suspense>
          </div>
        </div>
        <Link to={`../`} className="button" style={{ maxWidth: '100px', margin: '1rem auto', position: 'absolute', bottom: '0', left: '50%', transform: 'translateX(-50%)' }}>
          بازگشت
        </Link>
      </div>
    </section>
  )
}
